<template>
  <div class="links">
    <div class="links__items">
      <div
        v-for="(item, i) in items"
        :key="`item_${i}`"
        class="links__item"
      >
        <BaseLink :href="item.href" class="links__link">
          <span class="links__name" v-html="item.name" />
        </BaseLink>
      </div>
    </div>
  </div>
</template>

<script>
import BaseLink from '@/components/BaseLink.vue';

export default {
  name: 'TheLinks',
  components: {
    BaseLink,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="stylus">
.links
  display block
  font-size 1.3em

  &__items
    +landscape()
      display flex
      flex-wrap wrap
      justify-content space-between

  &__item
    margin-top 1.25em
    &:first-child
      margin-top 0
    +landscape()
      flex 0 0 50%
      max-width calc(50% - 1.5em)
      margin 0
      &:not(:nth-child(-n+2))
        margin-top 1.25em

  &__link
    &:after
      content '\2002\2192'
      display inline
      vertical-align middle
      font-size 1.4em

  &__name
    color #22215B
    font-weight 600
    line-height 1.5
    border-bottom solid 1px alpha(@color, 30%)
</style>
